import { render, staticRenderFns } from "./form-empresas.vue?vue&type=template&id=d735f242"
import script from "./form-empresas.vue?vue&type=script&lang=js"
export * from "./form-empresas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports